import { addCssClass, addOrRemoveCssClass, removeCssClass } from '../../dom';
import { _ as Utils } from '@ag-grid-community/core';
const ARROW_UP = '<ion-icon src="assets/icon/md/fnx_md-arrow-amount-up.svg" />';
const ARROW_DOWN = '<ion-icon src="assets/icon/md/fnx_md-arrow-amount-down.svg" />';
const HIGHLIGHT_CSS_CLASS = 'ag-value-change-value-highlight';
const DELTA_UP_CSS_CLASS = 'ag-value-change-delta-up';
const DELTA_DOWN_CSS_CLASS = 'ag-value-change-delta-down';
// eslint-disable-next-line
function instanceOfICellRendererComp(obj) {
    return (typeof obj.getGui === 'function' &&
        typeof obj.refresh === 'function');
}
// eslint-disable-next-line
export default function animateCellChange(config) {
    return function (target, propertyKey, descriptor) {
        if (!instanceOfICellRendererComp(target) || propertyKey !== 'refresh') {
            throw new Error('[AnimateCellChange decorator]: the decorator must be placed on the refresh lifecycle function of the AgGrid cell renderer');
        }
        const method = descriptor.value;
        descriptor.value = function (params) {
            var _a, _b, _c, _d;
            const isHighLight = config.highlight && this.eValue instanceof HTMLElement;
            const isDelta = config.delta && this.eDelta instanceof HTMLElement;
            if (config.highlight && !isHighLight) {
                console.error('[AnimateCellChange decorator]: HighLight configuration on but invalid html anchor');
            }
            if (config.delta && !isDelta) {
                console.error('[AnimateCellChange decorator]: Delta configuration on but invalid html anchor');
            }
            const oldValue = (_b = (_a = this.lastValue) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : this.lastValue;
            const result = method.call(this, params);
            if (params.colDef.suppressCellFlash) {
                return result;
            }
            const newValue = (_d = (_c = this.lastValue) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : this.lastValue;
            const isNeutral = newValue - oldValue === 0;
            if (isNeutral) {
                return result;
            }
            if (isHighLight && oldValue !== undefined) {
                addCssClass(this.eValue, HIGHLIGHT_CSS_CLASS);
            }
            if (isDelta && typeof newValue === 'number' && typeof oldValue === 'number') {
                const delta = newValue - oldValue >= 0;
                this.eDelta.innerHTML = delta ? ARROW_UP : ARROW_DOWN;
                // class makes it green (in ag-fresh)
                addOrRemoveCssClass(this.eDelta, DELTA_UP_CSS_CLASS, delta);
                // class makes it red (in ag-fresh)
                addOrRemoveCssClass(this.eDelta, DELTA_DOWN_CSS_CLASS, !delta);
            }
            if (this.refreshCount === undefined) {
                this.refreshCount = 0;
            }
            this.refreshCount++;
            const refreshCountCopy = this.refreshCount;
            setTimeout(() => {
                if (refreshCountCopy === this.refreshCount) {
                    if (config.highlight) {
                        removeCssClass(this.eValue, HIGHLIGHT_CSS_CLASS);
                    }
                    if (config.delta) {
                        Utils.clearElement(this.eDelta);
                        removeCssClass(this.eDelta, DELTA_UP_CSS_CLASS);
                        removeCssClass(this.eDelta, DELTA_DOWN_CSS_CLASS);
                    }
                }
            }, config.timer);
            return result;
        };
    };
}
